import { render } from "./Seilzugflaechen.vue?vue&type=template&id=428328a0&scoped=true&ts=true"
import script from "./Seilzugflaechen.vue?vue&type=script&lang=ts"
export * from "./Seilzugflaechen.vue?vue&type=script&lang=ts"

import "./Seilzugflaechen.vue?vue&type=style&index=0&id=428328a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428328a0"]])

export default __exports__